// Import Vue
import Vue from 'vue'

// Import F7
import Framework7 from 'framework7/framework7.esm.bundle.js'

// Import F7 Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js'

// Import F7 Styles
import Framework7Styles from 'framework7/css/framework7.css'

// Import Icons and App Custom Styles
import IconsStyles from './css/icons.css'
import AppStyles from './css/app.css'
import PlyrStyles from 'plyr/dist/plyr.css'
import QuillStyles from 'quill/dist/quill.snow.css'

// Import infinite loading with spinner
import InfiniteLoading from 'vue-infinite-loading'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Raters from 'vue-rate-it';

// Import App Component
import App from './app'

// Init F7 Vue Plugin
Framework7.use(Framework7Vue)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// import VueResource from 'vue-resource'

// Vue.use(VueResource)

import * as signalR from '@aspnet/signalr'
Vue.prototype.$signalR = signalR;


import moment from 'moment'

import VueDb from '@/modules/wrapper/VueDbPlugin'

import DbConfig from '@/modules/storage/dbConfig'

import * as AppReporting from '@/modules/appReporting/index'

import { GetAppGUID, FormatLongNumberIntoAbbreviator } from '@/modules/helper/index'

import { BootUpSync } from '@/modules/wrapper/dataProviderWrapper'

import { Register } from '@/modules/notification/index'

import DeviceInfo from '@/modules/util/deviceInfo'

import { IsUserActionAllow  } from "@/modules/helper/index";

import * as phonegap from '@/modules/phonegap/index'

import store from '@/store/store'

import { isPhoneGap } from '@/modules/util/util'

import { processStartUpUAQEntry } from '@/modules/uaq/uaqSync'
import { handleStatusBar, manageInputOnKeyboardOpen } from '@/modules/phonegap/index'
Vue.use(VueDb)

Vue.use({
  install (Vue, parameters) {
    Vue.prototype.$showLoader = function () {
      if (this.$store.getters.AppConfig.Subscription_GUID !== '4043EB8E-5789-4D5C-A8BB-079797E12D31') {
        this.$store.dispatch('showLoader')
      }
    }
    Vue.prototype.$hideLoader = function () {
      this.$store.dispatch('hideLoader')
    }
    Vue.prototype.$RegisterPageView = function (payload) {
      this.$store.dispatch('SaveRegiterPageViewEnter', payload)
    }
    Vue.prototype.$showModal = function (payload) {
      this.$store.dispatch('showModal', payload)
    }
  }
})
Vue.directive('mailto', function (el, binding) {
  el.href = 'mailto:' + binding.value
})
Vue.directive('tel', function (el, binding) {
  el.href = 'tel:' + binding.value
})
Vue.directive('formatLongNumber', function (el, binding) {
  // console.log('binding.value', binding.value)
  // let formatedValue = FormatLongNumberIntoAbbreviator(binding.value, 0)
  // console.log('formatedValue', formatedValue)
  el.innerHTML = binding.value
})

// Shared element
import Header from '@/components/shared/header/Header.vue'
import CircularImage from '@/components/shared/CircularImage.vue'
import FloatingButton from '@/components/shared/FloatingButton.vue'
import CommonComment from '@/components/shared/CommonComment.vue'
import UserRegistration from '@/components/shared/UserRegistration.vue'
import UserProfileEdit from '@/components/shared/UserProfileEdit.vue'
// import FacebookComents from '@/components/shared/FacebookComents.vue'
Vue.component('appHeader', Header)
Vue.component('appCircularImage', CircularImage)
Vue.component('appFloatingButton', FloatingButton)
Vue.component('appCommentForm', CommonComment)
Vue.component('appUserRegistration', UserRegistration)
Vue.component('appUserProfileEdit', UserProfileEdit)
//Vue.component('appFacebookComents', FacebookComents)
Vue.component('InfiniteLoading', InfiniteLoading)
Vue.component('PulseLoader', PulseLoader)
Vue.component('star-rating', Raters.StarRating);
Vue.component('image-rating', Raters.ImageRating);
// Shared Menu Layouts element
import TabMenu from '@/components/shared/menu-layout/TabMenu.vue'
import SideMenu from '@/components/shared/menu-layout/SideMenu.vue'
import GridMenu from '@/components/shared/menu-layout/GridMenu.vue'
import ListMenu from '@/components/shared/menu-layout/ListMenu.vue'
import MoreMenu from '@/components/shared/menu-layout/MoreMenu.vue'
Vue.component('appTabMenu', TabMenu)
Vue.component('appSideMenu', SideMenu)
Vue.component('appGridMenu', GridMenu)
Vue.component('appListMenu', ListMenu)
Vue.component('appMoreMenu', MoreMenu)

// //Stacked element
import Image from '@/components/stacked-elements/content-control/Image.vue'
import Title from '@/components/stacked-elements/content-control/Title.vue'
import Text from '@/components/stacked-elements/content-control/Text.vue'
import Line from '@/components/stacked-elements/content-control/Line.vue'
import ImageSlider from '@/components/stacked-elements/content-control/ImageSlider.vue'
import Accordion from '@/components/stacked-elements/content-control/Accordion.vue'
import InfoBox from '@/components/stacked-elements/content-control/InfoBox.vue'
import List from '@/components/stacked-elements/content-control/List.vue'
import Table from '@/components/stacked-elements/content-control/Table.vue'
import Map from '@/components/stacked-elements/content-control/Map.vue'
import Card from '@/components/stacked-elements/content-control/Card.vue'
import Button from '@/components/stacked-elements/content-control/Button.vue'
import LinkButton from '@/components/stacked-elements/content-control/LinkButton.vue'
import Video from '@/components/stacked-elements/content-control/Video.vue'
import Spacing from '@/components/stacked-elements/content-control/Spacing.vue'
import Tabs from '@/components/stacked-elements/content-control/Tab.vue'


Vue.component('AppImage', Image)
Vue.component('AppTitle', Title)
Vue.component('AppText', Text)
Vue.component('AppLine', Line)
Vue.component('AppImageslider', ImageSlider)
Vue.component('AppAccordion', Accordion)
Vue.component('AppInfobox', InfoBox)
Vue.component('AppList', List)
Vue.component('AppTable', Table)
Vue.component('AppMap', Map)
Vue.component('AppCard', Card)
Vue.component('AppButton', Button)
Vue.component('AppLink', LinkButton)
Vue.component('AppVideo', Video)
Vue.component('AppSpacing', Spacing)
Vue.component('AppTabs', Tabs)


import appTextInput from '@/components/stacked-elements/form-control/TextInput.vue'
import appSwitchGroup from '@/components/stacked-elements/form-control/SwitchGroup.vue'
import appDateInput from '@/components/stacked-elements/form-control/DateInput.vue'
import appTimeInput from '@/components/stacked-elements/form-control/TimeInput.vue'
import appRadioGroup from '@/components/stacked-elements/form-control/RadioGroup.vue'
import appCheckBoxGroup from '@/components/stacked-elements/form-control/CheckBoxGroup.vue'
import appPickerList from '@/components/stacked-elements/form-control/PickerList.vue'
import appSmartSelect from '@/components/stacked-elements/form-control/SmartSelectList.vue'
import appCalendar from '@/components/stacked-elements/form-control/Calender.vue'
import appSliderInput from '@/components/stacked-elements/form-control/SliderInput.vue'
import appNumberInput from '@/components/stacked-elements/form-control/NumberInput.vue'
import appSpinEdit from '@/components/stacked-elements/form-control/SpinEdit.vue'
import appRating from '@/components/stacked-elements/form-control/Rating.vue'
import appSatisfaction from '@/components/stacked-elements/form-control/Satisfaction.vue'
import Upload from '@/components/stacked-elements/form-control/Upload.vue'
Vue.component('appTextInput', appTextInput)
Vue.component('appSwitchGroup', appSwitchGroup)
Vue.component('appDateInput', appDateInput)
Vue.component('appTimeInput', appTimeInput)
Vue.component('appRadioGroup', appRadioGroup)
Vue.component('appCheckBoxGroup', appCheckBoxGroup)
Vue.component('appPickerList', appPickerList)

Vue.component('appSliderInput', appSliderInput)
Vue.component('appSmartSelect', appSmartSelect)
Vue.component('appCalendar', appCalendar)
Vue.component('appNumberInput', appNumberInput)
Vue.component('appSpinEdit', appSpinEdit)
Vue.component('appRating', appRating)
Vue.component('appSatisfaction', appSatisfaction)
Vue.component('AppUpload', Upload)

import Leaflet from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
Vue.component('v-map', Leaflet.Map)
Vue.component('v-tilelayer', Leaflet.TileLayer)
Vue.component('v-marker', Leaflet.Marker)
Vue.component('v-popup', Leaflet.Popup)
Vue.component('v-tooltip', Leaflet.Tooltip)

import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

const initVue = () => {
  // Init App
  new Vue({
    el: '#app',
    template: '<app/>',
    // Register App Component
    components: {
      app: App
    },
    store
  })
}

const init = async() => {
  let initTasks = []
  // let response = await Vue.axios.get('staticdata/appConfig.json')
  let appconfigURL = 'res/appConfig.json'
  if (!isPhoneGap()) {
    appconfigURL += '?dt=' + moment().unix()
  }
  initTasks.push(await axios.get(appconfigURL)
    .then(response => {

      console.log(response,AppReporting);
      //AppReporting.RegisterAppSessionStart()
      return response.data;
    })
    .catch(err => {
      console.log('get err', err)
    }))

  if (isPhoneGap()) {
    initTasks.push(phonegap.onDeviceReady()) // comment when test native db in browser
    // initTasks.push(phonegap.onDevicePause())
    // initTasks.push(phonegap.onDeviceResume())
  }
  const [response] = await Promise.all(initTasks)
  window.appConfig = response
console.log('URL Link=>>', Vue.axios.defaults)
  Vue.axios.defaults.baseURL = `${response.Urls.WebAPIURL}/api`
  Vue.axios.defaults.chatURL = `${response.Urls.ChatAPIURL}/api`
  // Vue.http.options.root = `${response.Urls.WebAPIURL}/api`
  window.appConfig.AppGUID = GetAppGUID(response.Subscription_Id)
  document.title = window.appConfig.AppName
  await AppReporting.RegisterApp(response.Subscription_Id)
  if (isPhoneGap()) {
    await AppReporting.RegisterApp(response.Subscription_Id)
    // Register(response.GcmKey, response.Subscription_Id)
    Vue.prototype.$notification = await Register(response.GcmKey, response.Subscription_Id) // comment when test native db in browser
    await Vue.InitDb(DbConfig)
    await Vue.MigrateDb(DbConfig)
    try {
      await BootUpSync(response.Subscription_Id)
      await processStartUpUAQEntry()
      } catch(error) {
      console.log('get err', error)
    }
  } else {
    await AppReporting.RegisterApp(response.Subscription_Id)
    // await Vue.InitDb(DbConfig)
    // await BootUpSync(response.Subscription_Id)
    // await processStartUpUAQEntry()
  }
  initVue()
}
init()
window.addEventListener('resize', function () {
  setTimeout(function() {
    if (DeviceInfo.isIOS) {
      handleStatusBar()
      //manageInputOnKeyboardOpen()
    }
  }, 0)
})



// WEBPACK FOOTER //
// ./src/main.js